import { InjectionToken } from '@angular/core';

export const HISTORY_TOKEN = new InjectionToken<History>('HISTORY_TOKEN');
